import { KeyTextPair, KeyTextPairUtils } from '../models/key-text-pair.model';

export enum UserPermission {
  CreateDynamicRule = 'createDynamicRule',
  CustomerList = 'customerList',
  Dashboard = 'dashboard',
  DynamicRuleList = 'dynamicRuleList',
  ShipmentVisibility = 'shipmentVisibility',
  TestHarness = 'testHarness',
  AccessorialCharges = 'accessorialCharges',
  AbsoluteMinimumCharges = 'absoluteMinimumCharges',
  DptRfpList = 'dptRfpList',
  DptDiscount = 'dptDiscount',
  CustomerGroups = 'customerGroups',
  PricingCodes = 'pricingCodes',
}

export class RamRolesOptions {
  static DpAnalyst: KeyTextPair = { key: '721', text: 'LTL_DP_ANALYST' };
  static DpAnalystTest: KeyTextPair = { key: '720', text: 'TST_LTL_DP_ANALYST' };
  static DpManager: KeyTextPair = { key: '723', text: 'LTL_DP_MANAGER' };
  static DpManagerTest: KeyTextPair = { key: '722', text: 'TST_LTL_DP_MANAGER' };
  static DpViewer: KeyTextPair = { key: '725', text: 'LTL_DP_VIEWER' };
  static DpViewerTest: KeyTextPair = { key: '724', text: 'TST_LTL_DP_VIEWER' };
  static DpITSupport: KeyTextPair = { key: '727', text: 'LTL_DP_IT' };
  static DpITSupportTest: KeyTextPair = { key: '726', text: 'TST_LTL_DP_IT' };

  static getAllTextValues(): string[] {
    return KeyTextPairUtils.getAllTextValues(Object.values(RamRolesOptions));
  }
}

const {
  DpAnalyst,
  DpManager,
  DpViewer,
  DpITSupport,
  DpAnalystTest,
  DpManagerTest,
  DpViewerTest,
  DpITSupportTest,
} = RamRolesOptions;

const allRoles = [DpAnalyst.text, DpManager.text, DpViewer.text, DpITSupport.text];
const allRolesTest = [DpAnalystTest.text, DpManagerTest.text, DpViewerTest.text, DpITSupportTest.text];
const noViewerRoles = [DpAnalyst.text, DpManager.text, DpITSupport.text];
const noViewerRolesTest = [DpAnalystTest.text, DpManagerTest.text, DpITSupportTest.text];
const itOnlyRoles = [DpITSupport.text];
const itOnlyRolesTest = [DpITSupportTest.text];

const makePermission = (roles: string[], testRoles: string[]) => ({
  User: { allowedRoles: roles },
  testUser: { allowedRoles: testRoles },
});

export const RamRolesPermissions = {
  [UserPermission.DptRfpList]: makePermission(allRoles, allRolesTest),
  [UserPermission.DynamicRuleList]: makePermission(allRoles, allRolesTest),
  [UserPermission.CustomerList]: makePermission(allRoles, allRolesTest),
  [UserPermission.CustomerGroups]: makePermission(allRoles, allRolesTest),
  [UserPermission.TestHarness]: makePermission(noViewerRoles, noViewerRolesTest),
  [UserPermission.ShipmentVisibility]: makePermission(allRoles, allRolesTest),
  [UserPermission.Dashboard]: makePermission(allRoles, allRolesTest),
  [UserPermission.AccessorialCharges]: makePermission(allRoles, allRolesTest),
  [UserPermission.AbsoluteMinimumCharges]: makePermission(allRoles, allRolesTest),
  [UserPermission.DptDiscount]: makePermission(allRoles, allRolesTest),
  [UserPermission.PricingCodes]: makePermission(itOnlyRoles, itOnlyRolesTest),
};
